/**
 * Accounts Receivable Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const accountsReceivableAPI = {
  getAll: (params) => apiClient.get('/accounts-receivable', { params }),
  getById: (id) => apiClient.get(`/accounts-receivable/${id}`),
  getByCustomer: (customerName, params) => apiClient.get(`/accounts-receivable/customer/${customerName}`, { params }),
  getSummary: (params) => apiClient.get('/accounts-receivable/stats/summary', { params }),
  getProjected: (params) => apiClient.get('/accounts-receivable/stats/projected', { params }),
  getAgingReport: (params) => apiClient.get('/accounts-receivable/reports/aging', { params }),
  getNextNumber: (params) => apiClient.get('/accounts-receivable/next-number', { params }),
  getBillAsOptions: (params) => apiClient.get('/accounts-receivable/bill-as-options', { params }),
  create: (data) => apiClient.post('/accounts-receivable', data),
  update: (id, data) => apiClient.put(`/accounts-receivable/${id}`, data),
  delete: (id) => apiClient.delete(`/accounts-receivable/${id}`),
  recordPayment: (id, data) => apiClient.post(`/accounts-receivable/${id}/payments`, data),
  deletePayment: (id, paymentId) => apiClient.delete(`/accounts-receivable/${id}/payments/${paymentId}`),
  convertToInvoice: (id) => apiClient.post(`/accounts-receivable/${id}/convert-to-invoice`),
  getSendOptions: (id) => apiClient.get(`/accounts-receivable/${id}/send-options`),
  sendInvoice: (id, data) => apiClient.post(`/accounts-receivable/${id}/send`, data),
};

export default accountsReceivableAPI;

